<h1 mat-dialog-title>Tierbemerkung hinzuf&uuml;gen</h1>

<div mat-dialog-content>
    <kiene-gruppe-tier-bemerkung #bemerkungComponent [dialog]="true" [tier]="tier" (saved)="dialogRef.close(tier)">
        <ng-container additional-actions>
            <button type="button" mat-button (click)="onCancelClick()">Abbrechen</button>
            <button type="button" mat-flat-button color="accent" (click)="onSaveClick()">Speichern</button>
        </ng-container>
    </kiene-gruppe-tier-bemerkung>
</div>
